import {Image} from "semantic-ui-react";
import React from "react";

export function CompanyLogo() {
  let src = "/am-logos/Kelvin.png";
  return <div style={{paddingLeft: "20px"}}>
    <Image src={src} size={"small"} />
  </div>
}